import { render } from "./activityFeed.vue?vue&type=template&id=ccbe34b0"
import script from "./activityFeed.vue?vue&type=script&lang=js"
export * from "./activityFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__